// Shared helper: friendlier geolocation error messages
export const geoErrorMessage = (e: any): string => {
    try {
        if (typeof window !== 'undefined' && !window.isSecureContext) {
            return 'Location requires HTTPS or localhost';
        }
    } catch { /* ignore */ }

    const code: number = Number((e && (e.code as any)) ?? NaN);
    switch (code) {
        case 1: // PERMISSION_DENIED
            return 'Permission denied — allow location access in your browser';
        case 2: // POSITION_UNAVAILABLE
            return 'Position unavailable — try again or check GPS';
        case 3: // TIMEOUT
            return 'Location timed out — try again near a window';
        default:
            return 'Unable to get current location';
    }
};

export const companyDomain = (url?: string) => {
    if (!url) return undefined;
    try {
        let s = url.trim();
        s = s.replace(/^https?:\/\//i, '').replace(/^www\./i, '');
        return s.split('/')[0];
    } catch {
        return url;
    }
};